import { BASE_ENDPOINT } from '../endpoints'

const main = `${BASE_ENDPOINT}/api/v1/`

export const createCheckouSessionUrl = `${main}create-checkout-session`
// Credits Endpoints
export const createConektaCreditsEndpoint =`${BASE_ENDPOINT}/api/v1/accounts/credits/createConektaOrder`;
export const saveCreditsOrder =`${BASE_ENDPOINT}/api/v1/accounts/credits/saveOrderAndCredits`;
export const getMyCredits =`${BASE_ENDPOINT}/api/v1/accounts/credits/getMyCredits`;
export const getMyHistoryCredits =`${BASE_ENDPOINT}/api/v1/accounts/credits/getHistoryCredits`;
export const getMyPostalCodeUrl =`${BASE_ENDPOINT}/api/v1/accounts/credits/getPostalCodeUser`;
// Permissions Endpoints
export const getAllMyPermissions = `${BASE_ENDPOINT}/api/v1/accounts/permissions/getMyPermissions`;
export const getUserIsAdmin = `${BASE_ENDPOINT}/api/v1/accounts/permissions/checkIsAdmin`;
export const getGroupsUsers = `${BASE_ENDPOINT}/api/v1/accounts/permissions/getAllGroupsUsers`;
export const saveGroupsUsers = `${BASE_ENDPOINT}/api/v1/accounts/permissions/saveUsersInGroups`;
export const deleteGroupsUsers = `${BASE_ENDPOINT}/api/v1/accounts/permissions/deleteUserFromGroup`;
// Conekta Emails Account
export const sendEmailCard = `${BASE_ENDPOINT}/api/v1/accounts/conekta/email-payment-card`;

// Password Endpoints
export const validateCurrentPasswordEndpoint = `${BASE_ENDPOINT}/api/v1/accounts/password/validate-current-password/`;
export const changePasswordEndpoint = `${BASE_ENDPOINT}/api/v1/accounts/password/change-password-verificat/`;
